/** Keep JSON data inert when HTML snapshots are parsed again (Appendix A.7 / §10.5). */
export function serializeJson(value: unknown): string {
  return (JSON.stringify(value) ?? 'null').replace(/</g, '\\u003c');
}
